import React from 'react';

type CitationLinkProps = {
  citationText: string;
  firstNumber: string;
  isClickable: boolean;
  onClick: (citationNumber: string) => void;
};

export function CitationLink({
  citationText,
  firstNumber,
  isClickable,
  onClick,
}: CitationLinkProps) {
  const display = `[${citationText}]`;

  if (isClickable) {
    return (
      <button
        onClick={() => onClick(`[${firstNumber}]`)}
        className="text-blue-600 dark:text-blue-400 hover:text-blue-700 dark:hover:text-blue-300 font-bold hover:underline cursor-pointer transition-colors"
        title={
          citationText.includes('-') || citationText.includes(',')
            ? `Click to view first product (${firstNumber})`
            : 'Click to view product details'
        }
      >
        {display}
      </button>
    );
  }

  return (
    <span
      className="text-blue-600 dark:text-blue-400 font-bold cursor-help"
      title="Source citation"
    >
      {display}
    </span>
  );
};
